// 统一封装接口方法,
// 每个方法负责请求一个url地址
// 逻辑页面，导入这个接口方法，就能发起请求
// 优点：请求url路径，可以在这里统一管理
// 只负责调用一个接口, 返回一个Promise对象

import axios from '@/utils/request.js'

// 用户 - 登录接口
export const loginAPI = ({ username, password }) =>
  axios({
    url: '/api/doLogin/login',
    // url: '/login',
    method: 'POST',
    changeOrigin: true,
    secure: false,
    data: {
      username,
      password
    }
  })
// 用户 - 登出接口
export const loginOut = (data) =>
  axios({
    url: '/api/doLogin/loginOut',
    // url: '/login',
    method: 'POST',
    changeOrigin: true,
    secure: false,
    data: data
  })
// 用户 - 获取当前登录用户信息
export const userProfileAPI = () =>
  axios({
    url: '/system/user/userInfo'
  })

/*
  首页
*/

export const getEquipmentOverview = () =>
  axios({
    url: '/api/comprehensiveSituation/getEquipmentOverview',
    method: 'POST',
  })

export const getAlarmStatistics = (data) =>
  axios({
    url: '/api/comprehensiveSituation/getAlarmStatistics',
    method: 'POST',
    data: data
  })

export const getUnitAlarmStatistics = (data) =>
  axios({
    url: '/api/comprehensiveSituation/getUnitAlarmStatistics',
    method: 'POST',
    data: data
  })

export const getSearchQuery = (data) =>
  axios({
    url: '/api/dataAnalysis/getSearchQuery',
    method: 'POST',
    data: data
  })

export const getDeviceList = (data) =>
  axios({
    url: '/api/device/getDeviceList',
    method: 'POST',
    data: data
  })

export const getAlgConfigList = (data) =>
  axios({
    url: '/api/algConfig/getAlgConfigList',
    method: 'POST',
    data: data
  })
